import React from "react";
import "./style/Footer.css";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-section text-light py-5">
      <div className="container">
        <div className="row g-4">
          {/* Logo & Description */}
          <div className="col-md-3">
            <img src="/assets/logo.png" alt="Logo" className="mb-3 footer-logo" />
            <p className="text-light footer-description">
              Shashila Enterprice is leading company of  Best Interior Designs Mosquito Protection and Pest control solutions.
              </p>
          </div>

          {/* About / Company Links */}
          <div className="col-md-3">
            <h5 className="fw-bold mb-3">Company</h5>
            <ul className="list-unstyled">
              <li><a href="/">Home</a></li>
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact Us </a></li>
              <li><a href="/testimonials"> Testimonials </a></li>
              <li><a href="/testimonials">FAQS Section</a></li>
              <li><a href="/whychooseus">WhyChooseUs </a></li>
            </ul>
          </div>

          {/* Services Links */}
          <div className="col-md-3">
            <h5 className="fw-bold mb-3">Services</h5>
            <ul className="list-unstyled">
              <li><a href="/interior">Interior Services</a></li>
              <li><a href="/pest-control">Pest Control Service</a></li>
              <li><a href="/mosquito">Insect Mosquito Protection</a></li>
              <li><a href="/housekeeping">House Keeping Service</a></li>
              <li><a href="/security">Security Guard Service</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-md-3">
            <h5 className="fw-bold mb-3">Quick Contacts</h5>
            <p className="text-warning"><FaEnvelope className="me-2" /> Shalishaenterprises@gmail.com</p>
            <p className="text-warning"><FaPhone className="me-2" /> (+91) 8473874372</p>
            <p><FaMapMarkerAlt className="me-2" /> Ho no-141, Narengi Chandrapur Road, Amgaon<br />Near Wedding Resort, Guwahati-781026</p>
          </div>
        </div>
      </div>
      <div className="mb-0 p-0 desinedby"><p className="text-center ">Designed by @<a href="https://www.litostindia.in/">Litost India</a></p></div>
    </footer>
  );
}